import React, { useState } from 'react';
import { Divider, MenuItem } from '@mui/material';

import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import AccordionQuoteHistory from '@/main/components/shared/accordionQuoteHistory/accordionQuoteHistory';
import { Controls } from '@/main/services/constants/constantsControl';
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from '@/main/services/utils';

import * as S from '../styles';
import { KeyValue } from '@/main/models/common';
import AccordionHistory from '@/main/screens/order/viewOrder/components/modalHistory/accordionHistory/accordionHistory';
import { useThreeDotsClaimContext } from '../contex';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { GetItemsBySupplierAllClaimRequest, GetItemsBySupplierRequest } from '@/main/models/request';
import ModalTracking from '@/main/screens/order/viewOrder/components/modalTracking/modalTracking';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { GetItemsBySupplierResponse } from '@/main/models/response';
import { procurementApi } from '@/main/api';

interface IThreeDotsClaimHistoryProps {
  guidClaim: string;
  hasAwaitingPayment: boolean;
  hasDeliveryBySupplier: boolean;
  hasProcurement: boolean;
}
function ThreeDotsClaimTracking({
  guidClaim,
  hasAwaitingPayment,
  hasDeliveryBySupplier,
  hasProcurement
}: IThreeDotsClaimHistoryProps) {

  const {
    closeThreeDotsClaim,
    generateIdMenu,
  } = useThreeDotsClaimContext();

  interface IGridDataTracking {
    data: GetItemsBySupplierResponse[][];
    totalItems: number;
    isLoading: boolean;

  }

const INITIAL_GRID_TRACKING_STATE: IGridDataTracking = {
  totalItems: 0,
  isLoading: false,
  data: []

  //UseState
};
const [gridDataTracking, setGridDataTracking] = useState<IGridDataTracking>(
  INITIAL_GRID_TRACKING_STATE
);
const [pageIndexTracking, setPageIndexTracking] = useState<number>(
  PaginationEnum.PageIndexIntial
);
const [isLoadingModalTracking, setIsLoadingModalTracking] = useState<boolean>(
  false
);
const [hasShowMoreTracking, setHasShowMoreTracking] = useState<boolean>(
  false
);
const [
  isLoadingInfiniteScrollTracking,
  setIsLoadingInfiniteScrollTracking
] = useState<boolean>(false);
const [
  formFiltersTracking,
  setFormFiltersTracking
] = useState<GetItemsBySupplierAllClaimRequest | null>(null);

  const [modalTracking, setModalTracking] = useState<boolean>(false);
  const showTrackingButton =  !hasAwaitingPayment && !hasDeliveryBySupplier &&  hasProcurement;

  function handleClick() {
    setModalTracking(true);
    onLoadTracking();
    closeThreeDotsClaim();
  }


  // Core function

  function onLoadTracking() {
    const index = pageIndexTracking + PaginationEnum.PageIndexIntial;
    setPageIndexTracking(index);
    const updatedFormFilters = {
      ...formFiltersTracking,
      guidClaim,
      pageIndex: pageIndexTracking,
      pageSize: PaginationEnum.PageSize5}
      onLoadInfiniteScrollTracking(updatedFormFilters);
    }


  function onLoadInfiniteScrollTracking(request: GetItemsBySupplierAllClaimRequest) {
    setIsLoadingInfiniteScrollTracking(true);

    procurementApi
      .getItemsSupplierAllClaim(request)
      .then(response => {
        const resultData = response.data?.results ?? [];
        const resultTotalItems = response.data?.totalNumberOfRecords ?? 0;

        const updatedData = [...gridDataTracking.data, ...resultData];

        setGridDataTracking({
          isLoading: false,
          totalItems: resultTotalItems,
          data: updatedData
        });


        setHasShowMoreTracking(updatedData.length < resultTotalItems);
      })
      .finally(() => setIsLoadingInfiniteScrollTracking(false));
  }


  return (
    <>
     {showTrackingButton && (
        <MenuItem
        id={generateIdMenu('tracking')}
        onClick={handleClick}
        >
         {getTranslateByKey('information.tracking')}
        </MenuItem>
      )}

       <KogModalSideComponent
        title={getTranslateByKey('information.tracking')}
        open={modalTracking}
        closeModal={() => {
          setModalTracking(false);
          setGridDataTracking(INITIAL_GRID_TRACKING_STATE);
          setPageIndexTracking(PaginationEnum.PageIndexIntial);
        }}
        padding="20px 0px 20px 20px">
          {gridDataTracking.data.map ((tracking) =>(
             <ModalTracking
             ignoreHeight={true}
             isLoadingModalTracking={isLoadingModalTracking}
             packTracking={tracking}
             infiniteScrollConfig={{
               dataLength: tracking.length,
               fetchData: () => onLoadTracking(),
               hasMore: hasShowMoreTracking,
               isLoading: isLoadingInfiniteScrollTracking,
               idScrollTarget: 'id-modal-scroll'
             }}
             orderNumber={''}
           />
          ))}

      </KogModalSideComponent>
    </>
  )
}

export { ThreeDotsClaimTracking };
